import { render, staticRenderFns } from "./CaptureCommentView.vue?vue&type=template&id=a77f5f0c&"
import script from "./CaptureCommentView.vue?vue&type=script&lang=js&"
export * from "./CaptureCommentView.vue?vue&type=script&lang=js&"
import style0 from "./CaptureCommentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports